module.exports = __webpack_public_path__ + "img/visicom.578da838.svg";